import { ResponseModel } from 'common/interfaces';
import { useFetch } from 'hooks/use-fetch/use-fetch';
import { useQuery } from 'react-query';
import { otpRequestConfig } from 'request-config/otp/otp.request-config';
import { useCreateDamageOtpLink } from 'pages/create-damage/hooks/use-otp-link';

export const useCheckOtpQuery = () => {
  const { createDamageOtpCode } = useCreateDamageOtpLink();
  const loadingKey = `checkOtp${createDamageOtpCode}`;

  const { fetch } = useFetch<ResponseModel<{ id: null | string }>>({
    loadingKey,
    isExcludeToken: true,
    ...otpRequestConfig.checkOtp(createDamageOtpCode as string)
  });

  const { data: checkOtpData, ...restQueryProps } = useQuery([loadingKey], () => fetch(), {
    enabled: !!createDamageOtpCode
  });

  return { otpId: checkOtpData?.data.data.id, createDamageOtpCode, ...restQueryProps };
};
